import type { Language } from '@/contexts/LanguageContext';

type SeoCopy = { title: string; description: string };

const HOME: Record<Language, SeoCopy> = {
  it: {
    title: 'HiroMatch — Software per selezionare personale | Prova gratis 7 giorni',
    description:
      'Pubblica annunci, screena CV con supporto AI e decidi chi assumere — tu resti in controllo. Prova gratuita 7 giorni per PMI europee.',
  },
  en: {
    title: 'HiroMatch — Hire with clarity | Free 7-day trial',
    description:
      'Publish roles, screen CVs with AI support, and decide who to hire — you stay in control. Free 7-day trial for European SMBs.',
  },
};

const CONTACT: Record<Language, SeoCopy> = {
  it: {
    title: 'Contattaci — HiroMatch',
    description: 'Richiedi informazioni, una demo o supporto per agenzie e PMI. Il team HiroMatch risponde via email.',
  },
  en: {
    title: 'Contact us — HiroMatch',
    description: 'Request information, a product demo, or agency and SMB support. The HiroMatch team replies by email.',
  },
};

const FAQ: Record<Language, SeoCopy> = {
  it: {
    title: 'Domande frequenti — HiroMatch',
    description:
      'Risposte su trial, piani, AI credits, candidati, privacy GDPR e funzionalità per recruiter e agenzie.',
  },
  en: {
    title: 'Frequently asked questions — HiroMatch',
    description:
      'Answers about trial, plans, AI credits, candidates, GDPR privacy, and features for recruiters and agencies.',
  },
};

export function homeSeo(lang: Language): SeoCopy {
  return HOME[lang === 'it' ? 'it' : 'en'];
}

export function contactSeo(lang: Language): SeoCopy {
  return CONTACT[lang === 'it' ? 'it' : 'en'];
}

export function faqSeo(lang: Language): SeoCopy {
  return FAQ[lang === 'it' ? 'it' : 'en'];
}
